import { Button, Grid } from "@mui/material";
import Filter from "common/Select/SelectMultiFilter";
import { useTranslation } from "react-i18next";
import DynamicSelect from "common/Select/Select";
import StyledField from "common/TextField/TexField1";
import { brandingInfo } from "features/server/brandingSlice";
import { useSelector } from "react-redux";
import { themes } from "theme/themes";

interface StockAdjustmentSearchHeaderComponentProps {
  handleChangeFilter: (event: any) => void;
  handleChangeSearch: (field: string, value: any) => void;
  handleSubmitSearch: () => void;
  searchFormData: any;
  filter: string[];
  clearSearch: () => void;
  storesData: any;
  handleDropdownActions: (
    typeName: string,
    action: "searchIt" | "loadNext",
    search?: string,
  ) => void;
  dropdownPage: number;
  searchLoading: string | null;
  dropdownSearchTerm: any;
  setDropdownSearchTerm: any;
  setDropdownPage: any;
  storesResponse: any;
}

const StockAdjustmentSearchHeader: React.FC<
  StockAdjustmentSearchHeaderComponentProps
> = ({
  handleChangeFilter,
  handleChangeSearch,
  handleSubmitSearch,
  searchFormData,
  filter,
  clearSearch,
  storesData,
  handleDropdownActions,
  storesResponse,
  dropdownPage,
  searchLoading,
  dropdownSearchTerm,
  setDropdownSearchTerm,
  setDropdownPage,
}) => {
  const { t } = useTranslation();
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const filterOptions = ["itemCode", "storeId"];
  const stores = storesData.map((item: { id: number; title: string }) => ({
    value: item.id,
    label: item.title,
  }));
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmitSearch();
    }
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Filter
            label="Filter By"
            filterOptions={filterOptions}
            handleChangeFilter={handleChangeFilter}
            filter={filter}
          />
        </Grid>
        {filter.map((fieldName) => (
          <>
            {fieldName === "storeId" ? (
              <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                <DynamicSelect
                  value={
                    searchFormData?.storeId
                      ? {
                          value: searchFormData?.storeId,
                          label:
                            searchFormData?.storeTitle ||
                            searchFormData?.storeId,
                        }
                      : null
                  }
                  isDisabled={false}
                  isRtl={false}
                  isSearchable={true}
                  name={`${fieldName}`}
                  options={stores}
                  isRequired={true}
                  onChange={(e) => handleChangeSearch(fieldName, e)}
                  label=""
                  onKeyDown={handleKeyPress}
                  isLoading={searchLoading === "stores"}
                  onInputChange={(
                    search: string,
                    { action }: { action: string },
                  ) => {
                    if (
                      action === "input-change" ||
                      (action !== "set-value" &&
                        action !== "menu-close" &&
                        action !== "input-blur")
                    )
                      handleDropdownActions("stores", "searchIt", search);
                    else if (
                      action === "input-blur" ||
                      action === "menu-close"
                    ) {
                      if (dropdownSearchTerm || dropdownPage > 1)
                        handleDropdownActions("stores", "searchIt", "");
                      else setDropdownSearchTerm("");
                      setDropdownPage(1);
                    }
                  }}
                  onMenuScrollToBottom={() => {
                    if (!(storesResponse?.pages[0]?.data as any).last)
                      handleDropdownActions("stores", "loadNext");
                  }}
                  page={dropdownPage}
                />
              </Grid>
            ) : (
              <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                <StyledField
                  fullWidth={true}
                  placeholder={t(fieldName)}
                  displayPlaceholder={true}
                  handleChange={(e) =>
                    handleChangeSearch(fieldName, e.target.value)
                  }
                  required={true}
                  value={searchFormData?.[fieldName] || ""}
                  handleKeyDown={handleKeyPress}
                />
              </Grid>
            )}
          </>
        ))}
        <Grid
          item
          xs={12}
          sm={6}
          md={2}
          sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
        >
          <Button
            variant="contained"
            disabled={filter.length ? false : true}
            onClick={handleSubmitSearch}
            sx={{
              boxShadow: "none",
              background: filter.length > 0 ? themeColors?.primary : "#B8C0C6",
            }}
            className={`text-white text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] h-[35px] px-8 py-1`}
          >
            {t("submit")}
          </Button>
          {filter.length ? (
            <Button
              variant="contained"
              onClick={clearSearch}
              sx={{ boxShadow: "none", color: themeColors?.primary }}
              className={`text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] bg-[#d8d1e0] h-[35px] px-8 py-1`}
            >
              {t("clear")}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};

export default StockAdjustmentSearchHeader;
